<forge-text-field [invalid]="isInvalid" [required]="isRequired">
    <textarea #input type="text" [formControl]="formControl" [rows]="rows" autocomplete="off"></textarea>

    <label *ngIf="!hideLabel" slot="label">{{label}}</label>

    <span slot="support-text-end" *ngIf="showMaxLengthHint">
        {{length}}/{{maxLength}}
    </span>

    <span slot="support-text">
        <ng-container *ngIf="hasError('required')">
            {{label}} is required
        </ng-container>

        <ng-container *ngIf="hasError('minlength')">
            {{label}} must be at least {{minLength}} characters long
        </ng-container>

        <ng-container *ngIf="hasError('maxlength')">
            {{label}} cannot be longer than {{maxLength}} characters
        </ng-container>

        <ng-container *ngIf="hasCustomValidators">
            <ng-container *ngFor="let customError of customErrors">
                <ng-container *ngIf="hasError(customError.errorKey)">
                    {{customError.message}}
                </ng-container>
            </ng-container>
        </ng-container>
    </span>
    <forge-tooltip *ngIf="tooltip">{{tooltip}}</forge-tooltip>
</forge-text-field>